import { LuChevronDown, LuSearch } from "@/Components/Icons/Icons.jsx";

export default {
  row1 :[
    {
      column: "column1",
      columnWidth: "48%",
      rows: {
        row1: [
          {
            name: "exportProductDUCRefNo",
            label: "DUC Ref No.",
            component: "text-field",
            width: "100%",
          }
        ],
        row2: [
          {
            name: "exportProductDUCRefNoSBDate", 
            label: "SB Date",
            component: "dateselector",
            width: "100%",
          },
        ],
        row3: [
          {
            name: "exportProductDUCRefNoBEDate",
            label: "BE Date",
            component: "dateselector",
            width: "100%",
          },
        ],
        row4: [
          {
            name: "exportProductDUCRefNoBEinvsr",
            label: "BE Inv.Sr.",
            component: "text-field",
           
            iconName: "Search",
            width: "100%",
          },
        ],
       
       
      },
    },
    {
      column: "colum2",
      columnWidth: "48%",
      rows: {
        row1: [
          {
            name: "exportProductDUCRefType",
            label: "Export Type",
            component: "dropdown",
             options: [
            { label: "RE-EXPORT", value: "RE-EXPORT" },
            { label: "NO-RE-EXPORT", value: "NO-RE-EXPORT" },
           
          ],
            endIconName: "LuChevronDown",
            width: "100%",
          },
        ],
      
        row2: [
          {
            name: "exportProductDUCRefNoBENo",
            label: "BE No.",
            component: "text-field",
            width: "100%",
          },
        ],
        row3: [
          {
            name: "exportProductDUCRefNoBEfieldat",
            label: "BE Filed at",
            component: "text-field",
             icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint : "getGateway",
            useParams : "general.exportTransportMode",
            endpointWithParams : "portType",
            width: "100%",
          },
        ],
          row4: [
          {
            name: "exportProductDUCRefNoBEitemsr",
            label: "BE Item Sr.",
            component: "text-field",
            iconName: "Search",
            width: "100%",
          },
        ],
        
      },
    },
  ]
};
  
